interface LogoProps {
  className?: string;
}

export function OpportunitiesPlusLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <g>
        <g>
          <g>
            <path 
              fill="currentColor" 
              d="M41.9,8.6c-4.5-4.8-11.7-5.9-17.5-2.7-.5.3-.6.8-.4,1.3.3.5.8.6,1.3.4h0c6.1-3.3,13.7-1.1,17.1,5,3.3,6.1,1.1,13.7-5,17.1-6.1,3.3-13.7,1.1-17.1-5-2-3.7-2-8.3,0-12,.3-.5,0-1.1-.4-1.3-.5-.3-1.1,0-1.3.4,0,.1-.2.3-.3.5h0c-3.6,7.2-.6,15.9,6.6,19.5,7.2,3.6,15.9.6,19.5-6.6,2.7-5.5,1.7-12-2.5-16.4h0Z" 
            />
          </g>
        </g>
        <g>
          <g>
            <path 
              fill="currentColor" 
              d="M44.4,5.6c-7.2-7.2-18.8-7.2-26,0-6.4,6.4-7.2,16.5-1.9,23.8l-3,3c-1.1-.5-2.4-.3-3.3.6L1.6,41.5c-1.9,1.9-1.9,5,0,6.8s5,1.9,6.8,0h0l8.5-8.5c.9-.9,1.1-2.2.6-3.3l3-3c8.2,6,19.7,4.1,25.7-4.1,5.3-7.3,4.5-17.4-1.9-23.8ZM15.6,38.5l-8.5,8.5c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1h0l8.5-8.5c.4-.4,1-.4,1.4,0l2.7,2.7c.4.4.4,1,0,1.4ZM16.3,35l-1.4-1.4,2.8-2.8c.2.2.4.5.7.7s.5.5.7.7l-2.8,2.8ZM43,30.2c-6.4,6.4-16.8,6.4-23.3,0s-6.4-16.8,0-23.3c6.4-6.4,16.8-6.4,23.3,0,0,0,0,0,0,0,6.4,6.4,6.4,16.8,0,23.2,0,0,0,0,0,0h0Z" 
            />
          </g>
        </g>
        <g>
          <g>
            <path 
              fill="currentColor" 
              d="M22.5,8.4s0,0,0,0c-.4-.4-1-.4-1.4,0-.4.4-.4,1,0,1.4,0,0,0,0,0,0h0c.4.4,1,.4,1.4,0,.3-.4.3-1,0-1.3h0Z" 
            />
          </g>
        </g>
      </g>
    </svg>
  );
}